import { getApiErrorStatus } from '../../../helpers/apiErrorHelper';
import { isSurveyOfflineError } from './surveyLoadFailure';

/** Submission responses can be lost after the server commits. Never claim
 * success/failure from a timeout, and never expose a server exception body.
 */
export const getSurveySubmissionErrorKey = (error: any): string => {
  const status = getApiErrorStatus(error);
  if (status === 401 || status === 498) return 'survey-submit-auth-error';
  if (status === 403 || status === 423) return 'survey-submit-forbidden';
  if (status === 404 || status === 409) return 'survey-submit-state-changed';
  if (error?.code === 'SURVEY_WRITE_TIMEOUT' || isSurveyOfflineError(error) || (status !== undefined && status >= 500)) {
    return 'survey-submit-unconfirmed';
  }
  return 'survey-submit-failed';
};
